import mentoApi from '@/api/mentoApi';

export interface CometChatToken {
  uid: string;
  authToken: string;
}

// Credentials deliberately bypass RTK Query: neither Redux state nor actions
// should retain the bearer. Reuse the normal Rails transport/casing instead.
export const requestCometChatToken = async (
  signal: AbortSignal,
): Promise<CometChatToken> => {
  try {
    const response = await mentoApi({
      data: {},
      method: 'POST',
      signal,
      url: '/comet_chat/auth_token',
    });
    const data = response.data as Partial<CometChatToken> | null;
    if (
      signal.aborted ||
      !data ||
      typeof data.uid !== 'string' ||
      !data.uid.trim() ||
      typeof data.authToken !== 'string' ||
      !data.authToken.trim()
    ) {
      throw new Error('Invalid chat credential');
    }
    return { authToken: data.authToken, uid: data.uid };
  } catch {
    // Axios errors can contain credentials, request config and response bodies.
    throw new Error('Chat authentication unavailable');
  }
};
